const PRECISION = 0.0002;

export default (n1: number, n2: number) => Math.abs(n1 - n2) < PRECISION;
